export const OPEN_PACIENTES_MODAL = 'OPEN_PACIENTES_MODAL'
export const CLOSE_PACIENTES_MODAL = 'CLOSE_PACIENTES_MODAL'
